export var payingDetailsMapper = function (data) {
    var result = {};
    if (data) {
        result.acCode = data.accode;
        result.payInFLM = data.payiN_FLM;
        result.payInFLQ = data.payiN_FLQ;
        result.payInFLY = data.payiN_FLY;
        result.payInFTM = data.payiN_FTM;
        result.payInFTQ = data.payiN_FTQ;
        result.payInFTY = data.payiN_FTY;
    }
    return result;
};
